import axios from 'axios';
import HTTP from '@/api';

export default (store) => {
  const loading = {
    increment(config) {
      if (config.handleLoading === undefined || config.handleLoading === true) {
        store.commit('loading/add', config);
      }
    },
    decrement(config) {
      store.commit('loading/remove', config);
    },
  };

  HTTP.interceptors.request.use(
    (config) => {
      loading.increment(config);
      return config;
    },
    (error) => {
      loading.decrement(error.config);

      if (error.config.handleErrors === undefined || error.config.handleErrors === true) {
        store.commit('alerts/addError');
      }

      return Promise.reject(error);
    },
  );

  HTTP.interceptors.response.use(
    (response) => {
      loading.decrement(response.config);

      if (response.data.errors && response.data.errors.length > 0) {
        store.commit('alerts/addError', { code: 500 });
        throw new axios.Cancel('Error occured on the server.');
      }

      return response;
    },
    (error) => {
      loading.decrement(error.config);

      if (error.config.handleErrors === undefined || error.config.handleErrors === true) {
        if (error.response) {
          if (error.response.status === 401) {
            store.dispatch('account/logout');
          }
          if (
            error.response.data
            && error.response.data.errors
            && error.response.data.errors.length > 0
          ) {
            store.commit('alerts/addError', { code: 500 });
          } else if (error.response.status) {
            store.commit('alerts/addError', { code: error.response.status });
          } else {
            store.commit('alerts/addError', { code: 500 });
          }
        } else if (error.request.status === 0) {
          store.commit('alerts/addError', { code: 500 });
        } else {
          store.commit('alerts/addError', { code: 500 });
        }
      }

      return Promise.reject(error);
    },
  );

  store.subscribe((mutation) => {
    if (mutation.type === 'account/token') {
      if (mutation.payload) {
        HTTP.defaults.headers.common['DevOps-Token'] = mutation.payload;
      } else {
        HTTP.defaults.headers.common['DevOps-Token'] = null;
      }
    }
  });
};
